const cardStyle = {
  background: 'rgba(255,255,255,0.97)', border: '1px solid #E2E8F0', borderRadius: 20,
  boxShadow: '0 8px 32px rgba(0,0,0,0.08)', padding: 24,
};

const STATUS_FLOW = ['draft', 'open', 'submissions_closed', 'matching', 'assigned', 'booking', 'active', 'completed'];

export default function EventDashboard({ event, eventDetail, onStatusChange, formUrl }) {
  const companies = eventDetail?.companies || [];
  const slots = eventDetail?.slots || [];

  return (
    <div>
      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        {[
          { label: 'Companies', value: companies.length, color: '#4F46E5' },
          { label: 'Submissions', value: 'View tab', color: '#c9a84c' },
          { label: 'Slots Assigned', value: slots.length, color: '#10B981' },
          { label: 'Max Slots', value: event.max_slots, color: '#64748B' },
        ].map((stat, i) => (
          <div key={i} style={cardStyle}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#94A3B8', fontFamily: 'Poppins, sans-serif', marginBottom: 4 }}>{stat.label}</div>
            <div style={{ fontFamily: '"EB Garamond", serif', fontSize: 32, fontWeight: 700, color: stat.color }}>{stat.value}</div>
          </div>
        ))}
      </div>

      {/* Submission form link */}
      <div style={{ ...cardStyle, marginBottom: 24 }}>
        <h3 style={{ fontFamily: '"EB Garamond", serif', fontSize: 18, color: '#0F172A', margin: '0 0 8px' }}>Public Submission Form</h3>
        <p style={{ fontSize: 13, color: '#94A3B8', fontFamily: 'Poppins, sans-serif', margin: '0 0 12px' }}>
          Share this link with inventors to submit their ideas
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input readOnly value={formUrl}
            style={{ flex: 1, padding: '10px 14px', borderRadius: 12, border: '2px solid #E2E8F0', fontSize: 13, fontFamily: 'Poppins, sans-serif', background: '#F8FAFC', color: '#0F172A' }} />
          <button onClick={() => navigator.clipboard.writeText(formUrl)}
            style={{ padding: '10px 20px', borderRadius: 12, background: '#0F172A', color: 'white', fontSize: 13, fontWeight: 600, fontFamily: 'Poppins, sans-serif', border: 'none', cursor: 'pointer' }}>
            Copy
          </button>
        </div>
      </div>

      {/* Event details */}
      {event.description && (
        <div style={{ ...cardStyle, marginBottom: 24 }}>
          <p style={{ fontSize: 14, color: '#64748B', fontFamily: 'Poppins, sans-serif', margin: 0, lineHeight: 1.6 }}>{event.description}</p>
        </div>
      )}

      {/* Status flow */}
      <div style={cardStyle}>
        <h3 style={{ fontFamily: '"EB Garamond", serif', fontSize: 18, color: '#0F172A', margin: '0 0 16px' }}>Event Status</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {STATUS_FLOW.map(s => {
            const isCurrent = event.status === s;
            const isPast = STATUS_FLOW.indexOf(s) < STATUS_FLOW.indexOf(event.status);
            return (
              <button key={s} onClick={() => onStatusChange(s)} style={{
                padding: '8px 16px', borderRadius: 12, fontSize: 12, fontWeight: 600,
                fontFamily: 'Poppins, sans-serif', border: 'none', cursor: 'pointer',
                background: isCurrent ? '#c9a84c' : isPast ? '#ECFDF5' : '#F1F5F9',
                color: isCurrent ? 'white' : isPast ? '#10B981' : '#64748B',
                boxShadow: isCurrent ? '0 2px 8px rgba(201,168,76,0.3)' : 'none',
                textTransform: 'capitalize',
              }}>
                {s.replace(/_/g, ' ')}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
